module.exports = __webpack_public_path__ + "media/images/cplook/apple-touch-icon-57x57-f2e13846e23e85ad51e8746d6270d137.png";